import { useMemo } from 'react';
import { isAndroid, isChrome, isDesktop, isIOS, isSafari } from 'react-device-detect';
import Native from '../utils/native';

type PlatformOSType = 'chrome' | 'safari' | 'edge' | 'native' | 'mobileBrowser' | 'default';

type MobileBrowser = 'ios' | 'android' | false;

type PlatformSpecific = {
  [platform in PlatformOSType]?: void | any;
};

interface IPlatform {
  OS: PlatformOSType;
  isNative: boolean;
  select<T>(
    specifics:
      | ({ [platform in PlatformOSType]?: T } & { default: T })
      | { [platform in PlatformOSType]: T }
  ): T;
  mobileBrowser: MobileBrowser;
}

export default function usePlatformService() {
  const isMobileBrowser = useMemo((): MobileBrowser => {
    switch (true) {
      case isIOS:
        return 'ios';
      case isAndroid:
        return 'android';
      default:
        return false;
    }
  }, []);

  const platformOs = useMemo((): PlatformOSType => {
    switch (true) {
      case !!Native.WebView:
        return 'native';
      case isDesktop && isChrome:
        return 'chrome';
      case isDesktop && isSafari:
        return 'safari';
      case !!isMobileBrowser:
        return 'mobileBrowser';
      default:
        return 'default';
    }
  }, []);

  const Platform: IPlatform = {
    OS: platformOs,
    isNative: platformOs == 'native',
    mobileBrowser: isMobileBrowser,
    select: (specifics: PlatformSpecific) => {
      return specifics[platformOs] ?? specifics.default;
    },
  };

  return Platform;
}
